/**
 * g2k Theme - Main Entry Point
 * 
 * Imports Tailwind CSS and theme JavaScript
 */


// Import jQuery and set globally
import $ from 'jquery';

// Import Tailwind CSS
import '../css/main.css';

// Import hamburger menu functionality
import './hamburger.js';

import { initGallerySwiper } from '../../template-parts/blocks/gallery/script.js';


// Theme initialization
console.log('g2k Theme loaded successfully! ✅');

(function () {
    document.addEventListener('DOMContentLoaded', () => {
        initGallerySwiper();

        const accordionButtons = document.querySelectorAll('.accordion-button');

        accordionButtons.forEach(button => {
            button.addEventListener('click', () => {
                const isExpanded = button.getAttribute('aria-expanded') === 'true';
                const content = document.getElementById(button.getAttribute('aria-controls'));
                const iconV = button.querySelector('.accordion-icon-v');

                // Toggle state
                if (isExpanded) {
                    button.setAttribute('aria-expanded', 'false');
                    content.classList.replace('grid-rows-[1fr]', 'grid-rows-[0fr]');
                    content.classList.replace('opacity-100', 'opacity-0');
                } else {
                    button.setAttribute('aria-expanded', 'true');
                    content.classList.replace('grid-rows-[0fr]', 'grid-rows-[1fr]');
                    content.classList.replace('opacity-0', 'opacity-100');
                }
                // Always toggle rotation on click
                iconV.classList.toggle('rotate-45');
            });
        });
    });
})();